import { useState } from "react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import logo from "../images/marriage.jpg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

export default function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [Confirmpassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [showEmailInput, setShowEmailInput] = useState(true);
  const [showTokenInput, setShowTokenInput] = useState(false);
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  
  const handleSendResetCode = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/users/forgetPassword/${email}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });
      setError(null);
      if (response.ok) {
        setLoading(false);
        setShowEmailInput(false);
        setShowTokenInput(true);
      } else {
        setLoading(false);
        setError(t('User not found. Please check your email.'));
      }
    } catch (error) {
      setLoading(false);
      setError(t('Internal server error 😞'));
    }
    
  };

  const handleVerifyResetCode = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/users/passwordReset/verifPasswordToken`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, resetToken: resetCode }),
      });
      setError(null);
      if (response.ok) {
        setLoading(false);
        setShowTokenInput(false);
        setShowPasswordInput(true);
      } else {
        setLoading(false);
        setError(t('Invalid reset code. Please try again.'));
      }
    } catch (error) {
      setLoading(false);
      setError(t('Internal server error 😞'));
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError(null);

       // Validate password requirements
  const passwordRegex = /^(?=.*[0-9])(?=.*[A-Z]).{6,50}$/;
  if (!passwordRegex.test(newPassword)) {
    setError(t('Password must contain at least 1 number, 1 uppercase letter, and be between 6 and 50 characters.'));
    return;
  }
    if (newPassword !== Confirmpassword) {
      setError(t('Passwords do not match.'));
    }

    try {
      setLoading(true);

      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/users/passwordReset/resetPassword`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, newPassword }),
      });
      if (Confirmpassword === newPassword) {
        if (response.ok) {
          Cookies.remove("user");
          setLoading(false);
          setSuccess(true);
          setTimeout(() => {
            navigate("/signin");
          }, 3000);
        }
      } else {
        setLoading(false);
        setError(t('Failed to reset password. Please try again.'));
      }
    } catch (error) {
      setLoading(false);
      setError(t('Internal server error 😞'));
    }
  };

  return (
    <>
      <div className="flex min-h-full flex-1">
       
        <div className="flex flex-1 flex-col justify-center px-4 py-5 sm:px-6 lg:flex-none lg:px-20 xl:px-24 ">
        
          <div className="mx-auto w-full max-w-sm lg:w-96">
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-pink-600"></div>
              </div>
            ) : success ? (
              <div>
                <div className="text-green-600 font-semibold text-2xl text-center mb-8">
                  {t('Password Reset Successfully!')}{" "}
                  <CheckCircleIcon
                    className="h-5 w-5 text-green-400 inline-block"
                    aria-hidden="true"
                  />
                </div>
              </div>
            )  : (
              <>
                <div>
                  <h2 className="text-2xl font-bold leading-9 tracking-tight text-gray-900 mb-4">
                    {t('Reset Your Password')}
                  </h2>
                </div>
                {error && (
              <div className="rounded-md bg-red-50 p-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg
                      className="h-5 w-5 text-red-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">
                      {error}
                    </h3>
                  </div>
                </div>
              </div>
            )}
                {showEmailInput && (
                  <form onSubmit={handleSendResetCode} className="space-y-6">
                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {t('E-mail')}
                      </label>
                      <div className="mt-0">
                        <input
                          placeholder={t('Enter your email')}
                          id="email"
                          name="email"
                          type="email"
                          autoComplete="off"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                          maxLength={50}
                        />
                      </div>
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="flex w-full justify-center rounded-md bg-pink-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                      >
                        {t('Send Reset Code')}
                      </button>
                    </div>
                  </form>
                )}

                {showTokenInput && (
                  <form onSubmit={handleVerifyResetCode} className="space-y-6">
                    <div>
                      <label
                        htmlFor="resetCode"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {t('Reset Code')}
                      </label>
                      <div className="mt-0">
                        <input
                          placeholder={t('Enter Reset Code')}
                          id="resetCode"
                          name="resetCode"
                          type="text"
                          autoComplete="off"
                          required
                          value={resetCode}
                          onChange={(e) => setResetCode(e.target.value)}
                          className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="flex w-full justify-center rounded-md bg-pink-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                      >
                        {t('Verify Code')}
                      </button>
                    </div>
                  </form>
                )}

                {showPasswordInput && (
                  <form onSubmit={handleResetPassword} className="space-y-6">
                    <div>
                      <label
                        htmlFor="newPassword"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {t('New Password')}
                      </label>
                      <div className="mt-0">
                        <input
                          id="newPassword"
                          name="newPassword"
                          type="password"
                          autoComplete="off"
                          required
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                      <label
                        htmlFor="Confirmpassword"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {t('Confirm Password')}
                      </label>
                      <div className="mt-0">
                        <input
                          id="Confirmpassword"
                          name="Confirmpassword"
                          type="password"
                          autoComplete="off"
                          required
                          value={Confirmpassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="flex w-full justify-center rounded-md bg-pink-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                      >
                        {t('Reset Password')}
                      </button>
                    </div>
                  </form>
                )}
              </>
            )}
          </div>
        </div>
        <div className="relative hidden min-w-screen min-h-screen flex-1 lg:block">
          <img
            className="absolute inset-0 w-full h-full object-cover"
            src={logo}
            alt="img"
          />
        </div>
        <div className="absolute bottom-0 right-0 mb-4 mr-4">
          <LanguageSwitcher />
          </div>
      </div>
    </>
  );
}
